//should be matched with snake case of CsvData
export const downloadTemplateJson = {
  ['PFH No.']: '',
  ['Credit Currency']: '',
  ['Credit Amount']: '',
};
